




import mixins from 'vue-typed-mixins';
import { DataSetContent } from '@/utils/DataSetUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => any,
    },
    label: {
      type: String as () => string,
    },
    datasetcontent: {
      type: Array as () => DataSetContent<void>[],
    },
    valueasstring: {
      type: Boolean as () => boolean,
    }
  },

  computed: {
    internal: {
      get(): string | undefined {
        if(this.valueasstring)
          return this.value;
        return this.value?.name ? this.$translate(this.value.name) : undefined;
      },
      set(internal?: any) {
        if (typeof internal === 'string') {
          if(this.valueasstring)
            this.$emit('input', internal);
          else
            this.$emit('input', { name: this.$languageobj(internal) });
        } else {
          if(this.valueasstring)
            this.$emit('input', this.$translate(internal.value.name));
          else
            this.$emit('input', internal.value);
        }
      },
    },

    options(): any {
      return this.datasetcontent?.map((content) => ({
        text: this.$translate(content.name),
        value: {
          id: content.id,
          name: content.name,
          content: content.content,
        },
      }));
    },
  },
});
